import { Component, Fragment } from 'react';
import styled from 'styled-components';
import { fontSize } from '../../../../../common/css/setting/variable';

import { IConvertedImages } from '../../../../../common/store/interface/IConvertedImages';
import { Page } from '../../../../../common/store/interface/Page';
import VisibleIf from '../../../../expert/common/components/js/VisibleIf';
import YadsNormal from '../../../containers/modules/YadsNormal';
import RankingItem from './RankingItem';

export interface IRankingProps {
  readonly title?: string;
  readonly url?: string;
  readonly isError: boolean;
  readonly list?: Array<{
    readonly rankingNumber: number;
    readonly headline: string;
    readonly mediaName: string;
    readonly newsLink: string;
    readonly isPay: boolean;
    readonly hasVideo: boolean;
    readonly duration?: string;
    readonly thumb: {
      readonly width: number;
      readonly height: number;
      readonly url: string;
    };
    readonly resizedThumbUrl: IConvertedImages | null;
    readonly dateString: string;
    readonly timeString: string;
  }>;
  readonly ultSec: string;
  readonly yadsDs?: string;
  readonly page?: Page;
  readonly typeTag?: string;
  readonly isShowAd?: boolean;
  readonly shannonId?: string;
  readonly categoryId?: string;
}
type IProps = IRankingProps;

const Title = styled.h2`
  padding: 4px;
  font-size: ${fontSize.px14};
  font-weight: bold;
  border-bottom: 1px solid ${props => props.theme.news.palette.bor_lv2_pc};
`;

const Link = styled.a`
  &:hover {
    text-decoration: underline;
  }
`;

const Section = styled.section`
  padding: 0 0 16px;
`;

export default class Ranking extends Component<IProps> {
  /**
   *
   */
  public render() {
    if (this.props.isError || !this.props.list) {
      return null;
    }

    const title = this.props.url ? (
      <Title>
        <Link href={this.props.url} data-cl-params={`_cl_vmodule:${this.props.ultSec};_cl_link:more;`}>
          {this.props.title}
        </Link>
      </Title>
    ) : (
      <Title>{this.props.title}</Title>
    );

    const ad = this.props.yadsDs ? (
      <VisibleIf condition={this.props.isShowAd ?? true}>
        <YadsNormal
          ds={this.props.yadsDs}
          parentElement={`yads_${this.props.yadsDs}`}
          isAdWithRightColumnFeed={true}
          page={this.props.page}
          typeTag={this.props.typeTag}
          isMainColumn={false}
          isNoTopBorder={false}
          isWithMarginBottom={false}
        />
      </VisibleIf>
    ) : null;

    return (
      <Fragment>
        <Section>
          <div id={this.props.ultSec}>
            {title}
            <ol>
              {this.props.list.map(article => (
                <RankingItem {...article} key={article.newsLink} ultSec={this.props.ultSec} />
              ))}
            </ol>
          </div>
        </Section>
        {ad}
      </Fragment>
    );
  }
}
